<ng-container *ngIf="taskId$ | async as taskId">
  <span class="task-label">Task ID</span>

  <span class="task-id">
    {{ taskId }}
  </span>

  <button
    mat-icon-button
    (click)="copyTaskUrl()"
    matTooltip="Click to copy task URL"
  >
    <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
  </button>
</ng-container>
